import { useState, useCallback } from "react";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";

/**
 * Fetches all clarification messages for an enquiry once and groups unread
 * counts by transporter, so a modal can badge a tab and per-transporter rows
 * without one get_clarification call per row.
 */
export const useEnquiryClarificationUnread = ({ enquiryId, currentUserEmail }) => {
  const [unreadByTransporter, setUnreadByTransporter] = useState({});

  const refresh = useCallback(() => {
    if (!enquiryId || !currentUserEmail) return;
    axios
      .get(`${Urls.spot}?field=get_clarification&enquiry_id=${enquiryId}`)
      .then((res) => {
        const messages = Array.isArray(res.data) ? res.data : [];
        const counts = {};
        messages.forEach((m) => {
          if (m.email === currentUserEmail || m.is_read) return;
          const id = m.for_transporter_id;
          if (!id) return;
          counts[id] = (counts[id] || 0) + 1;
        });
        setUnreadByTransporter(counts);
      })
      .catch(() => {});
  }, [enquiryId, currentUserEmail]);

  const totalUnread = Object.values(unreadByTransporter).reduce((sum, n) => sum + n, 0);

  return { unreadByTransporter, totalUnread, refresh };
};
